export default {
  meta: {
    title: '拓店任务管理',
    url: '/storemanage/expandtaskmng' // 埋点用，记录所属模块
  },
};
